module.exports = __webpack_public_path__ + "static/media/plus.2540b177.svg";